import Vue from 'vue'
import Vuex from 'vuex'
import companiesModule from '@/vuex/companies/companies'
import projectsModule from '@/vuex/projects/projects'
import mapModule from '@/vuex/map/map'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    companies: companiesModule,
    projects: projectsModule,
    map: mapModule,
  },
})
